import { OpaccAjax } from './classes/opacc.class.ajax.js';
import { OpaccLog } from './classes/opacc.class.log.js';
import { OpaccLocalstorage } from './classes/opacc.class.localstorage.js';
import { OpaccStore } from './classes/opacc.class.store.js';
import { OpaccSanitize } from './classes/opacc.class.sanitize.js';

export const opaccAjaxPlugin = new OpaccAjax();
export const opaccLogPlugin = new OpaccLog();
export const opaccLocalStoragePlugin = new OpaccLocalstorage();
export const opaccStorePlugin = new OpaccStore();
export const opaccSanitizePlugin = new OpaccSanitize();